import React from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';

export const Contact = () => {
  return (
    <div className="min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-fredoka font-bold text-[#1A1A2E] mb-6" data-testid="contact-page-title">
            Contacto
          </h1>
          <p className="text-xl text-[#4A4A6A] font-quicksand max-w-3xl mx-auto">
            ¿Tienes alguna pregunta? Estamos aquí para ayudarte
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg" data-testid="contact-info-phone">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#00C2CB]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-[#00C2CB]" />
                </div>
                <div>
                  <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-2">Teléfono</h3>
                  <a
                    href="tel:3146758677"
                    className="text-[#4A4A6A] font-quicksand text-lg hover:text-[#00C2CB] transition-colors"
                  >
                    314 675 8677
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg" data-testid="contact-info-whatsapp">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#FFD700]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Send className="w-6 h-6 text-[#FFD700]" />
                </div>
                <div>
                  <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-2">WhatsApp</h3>
                  <a
                    href="https://wa.me/573146758677"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#4A4A6A] font-quicksand text-lg hover:text-[#00C2CB] transition-colors"
                  >
                    Enviar mensaje
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg" data-testid="contact-info-email">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#FF6B00]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-[#FF6B00]" />
                </div>
                <div>
                  <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-2">Correo</h3>
                  <a
                    href="mailto:info@diversytoys.com"
                    className="text-[#4A4A6A] font-quicksand text-lg hover:text-[#00C2CB] transition-colors"
                  >
                    info@diversytoys.com
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg" data-testid="contact-info-address">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#00C2CB]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-[#00C2CB]" />
                </div>
                <div>
                  <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-2">Dirección</h3>
                  <p className="text-[#4A4A6A] font-quicksand text-lg">
                    Cra 48 # 49-21 Local 113
                    <br />
                    CC Colonial / Rionegro - Antioquia
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg" data-testid="contact-info-hours">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#FFD700]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-[#FFD700]" />
                </div>
                <div>
                  <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-2">Horario</h3>
                  <p className="text-[#4A4A6A] font-quicksand text-lg">
                    Lunes a Sábado
                    <br />
                    9:00 AM - 7:00 PM
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden h-full min-h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.8303779683647!2d-75.3723785!3d6.1534667999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e469fa08aae6d1b%3A0x912abb9aa8437bc7!2sJugueter%C3%ADa%20DIVERSYTOYS!5e0!3m2!1ses-419!2sco!4v1777434800405!5m2!1ses-419!2sco"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Diversytoys Location"
              data-testid="contact-map"
            />
          </div>
        </div>

        {/* Instagram */}
        <div className="mt-12 text-center bg-gradient-to-br from-[#00C2CB]/10 via-[#FFD700]/10 to-[#FF6B00]/10 rounded-3xl p-12">
          <h2 className="text-3xl font-fredoka font-bold text-[#1A1A2E] mb-4">
            Síguenos en Instagram
          </h2>
          <p className="text-lg text-[#4A4A6A] font-quicksand mb-6">
            @jugueteria_diversytoys
          </p>
          <a
            href="https://www.instagram.com/jugueteria_diversytoys"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-purple-500 to-pink-500 text-white px-8 py-4 rounded-full font-fredoka font-bold text-lg hover:scale-105 transition-all duration-300 shadow-lg"
            data-testid="instagram-link"
          >
            Visitar Instagram
          </a>
        </div>
      </div>
    </div>
  );
};